import { FormElement } from '../../lib/types'
import React, { useEffect, useMemo, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import getId from '../../lib/get-id'
import remarkGfm from 'remark-gfm'
import { useParams } from 'react-router-dom'
import { getWorkflowConfig } from '../../workflows/util'
import auth from '../../lib/auth'

type Props = {
    element: FormElement
    data: any
    reviewerOnly?: Boolean
}

export default function MarkdownElement(props: Props) {
    const { element, data } = props
    const { id } = useParams()
    const [access, setAccess] = useState(false)

    useEffect(() => {
        getWorkflowConfig(Number(id)).then((config) => {
            let roles = config ? config.users.map(user => {
                if (user.id === Number(auth.user?.sub)) {
                    return user.role
                }
                return null
            }) : []
            if (roles.includes('reviewer')) {
                setAccess(true)
            } else {
                setAccess(false)
            }
        })
    }, [id])

    let content = useMemo(() => {
        let id = ''
        try {
            id = String(getId(data))
        } catch (e) {
            // console.log(e)
        }
        let content = element.content!.replace(/{{id}}/g, id)

        // Allow templating from data
        for (let key of Object.keys(data)) {
            let re = new RegExp('{{' + key + '}}', 'g')
            content = content.replace(re, String(data[key]))
            if (content.includes('{{encode:' + key)) {
                let re = new RegExp('{{encode:' + key + '}}', 'g')
                content = content.replace(re, encodeURIComponent(String(data[key])))
            }
        }
        return content
    }, [element, data])

    if (!props.reviewerOnly || (props.reviewerOnly && access)) {
        return (
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                children={content}
                components={{
                    a: ({ node, ...props }) => (
                        <a target='_blank' {...props}>
                            {props.children}
                        </a>
                    ),
                }}
            />
        )
    } else {
        return <div></div>
    }
}
